import { TagName, type News, type NewsCDS, type NewsDetailsCDS } from '$lib/types/news';
import { createSlug } from '$lib/utils';

/**
 * Creates a url for the news category page.
 * @param category Category of the news
 * @returns url of the news category
 */
export const createNewsCategoryUrl = (category: string) => {
  return `/news/${createSlug(category)}`;
};

/**
 * Creates a url for the news details page.
 * @param category Category of the news
 * @param id Post id of the news
 * @returns url of the news
 */
export const createNewsDetailsUrl = (category: string, id: string) => {
  return `/news/${createSlug(category)}/${id}`;
};

/**
 * Gets the hero image of the news.
 * @param news News object
 * @returns hero image of the news
 */
export const getHeroImage = (news: NewsCDS | News | NewsDetailsCDS) => {
  return (
    news.images.find((image) => image.tagName === TagName.SwishNewsArticleMainImage)
      ?.supportedImages?.original || ''
  );
};

/**
 * Gets the hero image of the news video.
 * @param news News object
 * @returns hero image of the news
 */
export const getHeroVideoImage = (news: NewsCDS | News | NewsDetailsCDS) =>
  news.images.find((image) => image.tagName === TagName.SwishNewsCardLandscapeImage)
    ?.supportedImages?.original || '';

/** Checks if the news is of type NewsCDS or News */
export const isNewsCDS = (news: News | NewsCDS): news is NewsCDS => {
  return (news as NewsCDS).sys !== undefined;
};

/**
 * Unique News
 */
export const uniqueNews = (news: NewsCDS[]) => {
  const uniqueNews = news.reduce((acc, curr) => {
    const found = acc.find((item) => item.sys.id === curr.sys.id);
    if (!found) {
      return acc.concat([curr]);
    } else {
      return acc;
    }
  }, [] as NewsCDS[]);

  return uniqueNews;
};

export const imageNewsFilter = (news: (News | NewsCDS)[]) => news;
